import * as React from "react";
import Component from "../../AbstractComponent";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";


export default class CompanyDetailsEditable extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}
	
  public render() {
		const company: CompanyInterface = this.props.company;
		
		return (
			<React.Fragment>
				<div className="charge-summary">
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
						<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
							{this.trans("label-company")}
						</div>
					</div>
					<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
						<div className="counterparty">
							{`${company?.displayName}`}
						</div>
					</div>
					<table>
						{
							company?.generalContact && (
								<tr>
									<td className="align-left first-column">
										{`${this.trans("label/agency-general-contact")}: `}
									</td>
									<td className="align-left">
										<div className="margin-wrapper">
											<div 
												className="link-to-entity" 
												onClick={() => this.redirect(`/app/person/update/${company.generalContactId}/`)}
											>
												{`${company?.generalContact?.displayName}`}
											</div>
										</div>
									</td>
								</tr>
							)
						}
					</table>
				</div>
				{this.props.editableFields}
			</React.Fragment>
		);
  }
}
